/**
 * Unified loading component for all Settings list pages.
 * Provides consistent skeleton loader UI with reserved layout height.
 */
export const SettingsListLoading = () => {
  return (
    <div className='space-y-3'>
      {[1, 2, 3].map((i) => (
        <div
          key={i}
          className='rounded-2xl border border-sd-border bg-sd-card shadow-sm p-5'
        >
          <div className='animate-pulse flex items-start gap-4'>
            <div className='h-10 w-10 rounded-lg bg-sd-muted shrink-0'></div>
            <div className='flex-1 space-y-3'>
              <div className='h-4 bg-sd-muted rounded w-3/4'></div>
              <div className='h-3 bg-sd-muted rounded w-1/2'></div>
            </div>
            <div className='h-8 w-20 bg-sd-muted rounded shrink-0'></div>
          </div>
        </div>
      ))}
    </div>
  );
};
